import { httpClient } from 'api/clients/httpClient'
import { Contributor, ShowDTO, ShowWithImages, ShowWithImagesDTO } from 'types/Show'

export const createShow = async (showData: ShowDTO): Promise<any> => {
    const { data } = await httpClient.post('/shows', {
        showData,
    })

    return data
}

export const updateShow = async (showId: string, showData: ShowWithImagesDTO, partnerId?: string): Promise<any> => {
    try {
        const payload = {
            ...showData,
        }

        const config = partnerId ? { params: { partnerId } } : {}

        const { data } = await httpClient.put(`/shows/${showId}`, payload, config)
        return data
    } catch (error) {
        throw new Error('Failed to update show')
    }
}

export const getShows = async (searchTerm = '', isAdmin = false, partnerId?: string): Promise<ShowWithImages[]> => {
    try {
        const basePath = isAdmin ? '/shows/admin' : '/shows'
        const params: any = { search: searchTerm }

        if (isAdmin && partnerId) {
            params.partnerId = partnerId
        }

        const { data } = await httpClient.get(basePath, { params })

        const processData: ShowWithImages[] = data.map((current: any) => {
            const contributors =
                typeof current.contributors === 'string' ? (JSON.parse(current.contributors) as Contributor[]) : current.contributors

            return {
                ...current,
                contributors,
            }
        })

        return processData
    } catch (error) {
        console.error('Error fetching shows:', error)
        throw error
    }
}

export const getShowById = async (id: string): Promise<ShowWithImages> => {
    try {
        const { data } = await httpClient.get(`/shows/${id}`)

        const processedData: ShowWithImages = {
            ...data,
            contributors: typeof data.contributors === 'string' ? (JSON.parse(data.contributors) as Contributor[]) : data.contributors,
        }

        return processedData
    } catch (error) {
        console.error('Error fetching show by ID:', error)
        throw error
    }
}

export const getShowByIdAdmin = async (id: string): Promise<ShowWithImages> => {
    try {
        const { data } = await httpClient.get(`/shows/admin/${id}`)

        const processedData: ShowWithImages = {
            ...data,
            contributors: typeof data.contributors === 'string' ? (JSON.parse(data.contributors) as Contributor[]) : data.contributors,
        }

        return processedData
    } catch (error) {
        console.error('Error fetching show by ID:', error)
        throw error
    }
}

export const deleteShow = async (id: string): Promise<ShowWithImages> => {
    const { data } = await httpClient.delete(`/shows/${id}`)

    return data
}
